import { usePublicSettings } from '../../hooks/usePublicSettings';
import { resolveLogoSrc } from '../../utils/logoSrc';

const Logo = () => {
  const { logoUrl, companyName } = usePublicSettings();
  const logoBucketUrl = import.meta.env.VITE_LOGO_BUCKET_URL ?? '';
  const src = resolveLogoSrc(logoUrl, logoBucketUrl);

  if (src) {
    return <img src={src} alt={companyName || 'Company Logo'} className="logo-image" />;
  }

  return companyName ? (
    <span>{companyName}</span>
  ) : null;
};

export default Logo;
